import Box from '@material-ui/core/Box';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import CardHeader from '@material-ui/core/CardHeader';
import Grid from '@material-ui/core/Grid';
import { useMutation } from 'butler';
import { Form, Formik } from 'formik';
import React, { useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import FormTextField from '../../form/FormTextField';
import FormSelectField from '../../form/FormSelectField';
import useCreateRecordApi from '../../api/useCreateRecordApi';
import ButtonWithSpinner from '../components/ButtonWithSpinner';
import PositiveButton from '../components/PositiveButton';
import UploadRecordZone from './UploadRecordZone';
const initialValues = {
    accountMonth: undefined,
    accountYear: new Date().getFullYear(),
    monthlyAccounts: undefined,
};
const CreateRecordComponent = ({ companyId, erpType }) => {
    const history = useHistory();
    const uploadRecordApi = useCreateRecordApi();
    const [mutate] = useMutation(uploadRecordApi.handleRequest);
    const onSubmit = useCallback(async (values, formikHelpers) => {
        try {
            const uploaded = await mutate({
                formik: formikHelpers,
                values,
                companyId,
            });
            if (uploaded) {
                history.push(`/company/${companyId}`);
            }
        }
        catch (e) { }
    }, [mutate, history]);
    return (React.createElement(Box, { width: "100%" },
        React.createElement(Formik, { validationSchema: uploadRecordApi.validation, onSubmit: onSubmit, initialValues: {
                record: {
                    ...initialValues,
                },
            } }, (formikProps) => (React.createElement(Form, { noValidate: true, method: "POST" },
            React.createElement(Card, null,
                React.createElement(CardHeader, { title: "Upload new Month" }),
                React.createElement(CardContent, null,
                    React.createElement(Grid, { container: true, spacing: 6 },
                        React.createElement(Grid, { item: true, xs: 12, sm: 12 },
                            React.createElement(UploadRecordZone, { erpType: erpType, hasRecord: Boolean(formikProps.values?.record
                                    ?.monthlyAccounts), onChange: (accounts) => {
                                    formikProps.setFieldValue('record.monthlyAccounts', accounts);
                                }, disabled: formikProps.isSubmitting, error: formikProps.errors?.record
                                    ?.monthlyAccounts })),
                        React.createElement(Grid, { item: true, xs: 12, sm: 6 },
                            React.createElement(FormSelectField, { fullWidth: true, variant: "outlined", name: "record.accountMonth", label: "Month", options: uploadRecordApi.monthOptions })),
                        React.createElement(Grid, { item: true, xs: 12, sm: 6 },
                            React.createElement(FormTextField, { fullWidth: true, name: "record.accountYear", label: "Year", type: "number", variant: "outlined" })))),
                React.createElement(CardActions, null,
                    React.createElement(Box, { padding: 1, width: "100%", display: "flex", justifyContent: "flex-end", position: "relative" },
                        React.createElement(ButtonWithSpinner, { type: "submit", disabled: formikProps.isSubmitting, variant: "contained", button: PositiveButton, disableElevation: true }, "Upload Record")))))))));
};
export default CreateRecordComponent;
